import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { MyPipelineService } from 'src/services/api/MyPipelineService';

const STALE_TIME = 1000 * 30; // 30s — status can change from recruiter-side actions

/** Paginated list of the candidate's outreach ("interest request") records. */
export function useInterestRequests({ page = 1, pageSize = 10 } = {}) {
  return useQuery({
    queryKey: ['myPipelines', 'interestRequests', page, pageSize],
    queryFn: () => MyPipelineService.getInterestRequests({ page, pageSize }),
    placeholderData: keepPreviousData,
    staleTime: STALE_TIME,
  });
}

/** Paginated list of the candidate's interview records. */
export function useInterviews({ page = 1, pageSize = 10 } = {}) {
  return useQuery({
    queryKey: ['myPipelines', 'interviews', page, pageSize],
    queryFn: () => MyPipelineService.getInterviews({ page, pageSize }),
    placeholderData: keepPreviousData,
    staleTime: STALE_TIME,
  });
}
